import ResetPassword from 'src/components/ResetPassword/ResetPassword';
import { connect } from 'react-redux';
import { FrameworkActionCreator, CustomerActionCreator, VehiclesActionCreator } from 'src/store/states';
import { IStoreState } from 'src/store';

const mapStateToProps = (state: IStoreState) => ({
    custInfo: state.Customer!['Customer'],
    specProfile: state.Framework.specProfile,
    store: state.Framework.store,
    branch: state.Framework.branch,
    errMsg: state.Customer!.errMsg,
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
    vehicles: state.Vehicles.vehicles,
    selectedVehicle: state.Vehicles.selectedVehicle,
    locale: state.Framework.locale,
});

const mapDispatchToProps = {
    pushToMainPanes: FrameworkActionCreator.pushToMainPane,
    resetCustPassword: CustomerActionCreator.ResetCustPassword,
    ClearTokenData: FrameworkActionCreator.ClearTokenData,
    clearError: CustomerActionCreator.CustomerClearError,
    clearCustInfo: CustomerActionCreator.ClearCustInfo,
    clearMainPanes: FrameworkActionCreator.clearMainPanes,
    getVehicles: VehiclesActionCreator.GetVehicles,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ResetPassword);